module.exports = "<ng-template #dialogcontainer>\n</ng-template>\n"